export function setContingencies(state, payload) {
  state.contingencies = payload;
}
